/* src/app/views/collection/components/modals/collection-reload-displays-modal/collection-reload-displays-modal.component.scss */
.background-white {
  background-color: #fff;
}
/*# sourceMappingURL=collection-reload-displays-modal.component.css.map */
